import { render, staticRenderFns } from "./basic_display.vue?vue&type=template&id=985bea26&scoped=true&"
import script from "./basic_display.vue?vue&type=script&lang=js&"
export * from "./basic_display.vue?vue&type=script&lang=js&"
import style0 from "./basic_display.vue?vue&type=style&index=0&id=985bea26&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985bea26",
  null
  
)

export default component.exports